import email2 from '../assets/email2.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

import whatsapp from '../assets/whatsapp.png';
import userEmpty from '../assets/user-empty.png';

export default {
  whatsapp,
  email2,
  mobile,
  api,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  logo2,
  userEmpty,
};
